module.exports = __webpack_public_path__ + "static/media/score.6fea9d61.png";